import { Link } from "react-router-dom";
import { BookOpen, Library, Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useTheme } from "next-themes";

const Header = () => {
  const [language, setLanguage] = useState<"en" | "fr">("en");
  const { theme, setTheme } = useTheme();

  const toggleLanguage = () => {
    setLanguage(prev => prev === "en" ? "fr" : "en");
  };

  return (
    <header className="border-b bg-card/50 backdrop-blur sticky top-0 z-50">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <BookOpen className="h-6 w-6 text-primary" />
          <span className="text-xl font-bold">FaydaLibrary</span>
        </Link>
        
        <nav className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-sm font-medium hover:text-primary transition-colors">
            {language === "en" ? "Home" : "Accueil"}
          </Link>
          <Link to="/library" className="text-sm font-medium hover:text-primary transition-colors">
            {language === "en" ? "Browse Library" : "Bibliothèque"}
          </Link>
          <Link to="/about" className="text-sm font-medium hover:text-primary transition-colors">
            {language === "en" ? "About" : "À propos"}
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          {/* Language Toggle */}
          <div className="flex items-center bg-muted rounded-full p-1">
            <Button
              variant={language === "en" ? "default" : "ghost"}
              size="sm"
              onClick={toggleLanguage}
              className="rounded-full h-8 px-3 text-xs font-medium"
            >
              EN
            </Button>
            <Button
              variant={language === "fr" ? "default" : "ghost"}
              size="sm"
              onClick={toggleLanguage}
              className="rounded-full h-8 px-3 text-xs font-medium"
            >
              FR
            </Button>
          </div>

          {/* Theme Toggle */}
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            className="rounded-full"
          >
            <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
            <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
            <span className="sr-only">Toggle theme</span>
          </Button>

          <Button variant="ghost" size="icon" asChild className="md:hidden">
            <Link to="/library">
              <Library className="h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
